import httpClient from '../../utils/httpClient';

export const getRecruiterProfile = async ({ queryKey: [_, { id }] }) => {
  const { data } = await httpClient.get(`/user/recruiter?id=${id}`);
  return data;
};
